const API_URL = 'https://api.fealexpert.ru/crm-api';
export default API_URL;
